import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 24 24",
  class: "yb-svg-icon"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", null, [
      _createElementVNode("path", {
        d: "M22.29,16.12a3,3,0,0,0,0-4.24l-11-11A3,3,0,0,0,9.17,0H2A2,2,0,0,0,0,2V9.17a3,3,0,0,0,.88,2.12l11,11a3,3,0,0,0,4.24,0Zm-1.41-1.41L14.7,20.88a1,1,0,0,1-1.41,0l-11-11A1,1,0,0,1,2,9.17V2.5A.5.5,0,0,1,2.5,2H9.17a1,1,0,0,1,.71.29l11,11a1,1,0,0,1,0,1.42Z",
        fill: "#4b5357"
      }),
      _createElementVNode("circle", {
        cx: "6",
        cy: "6",
        r: "1.5",
        fill: "#4b5357"
      })
    ], -1)
  ])))
}
export default { render: render }